import { render, staticRenderFns } from "./IndustryInfo.vue?vue&type=template&id=c971b3c4&scoped=true&"
import script from "./IndustryInfo.vue?vue&type=script&lang=js&"
export * from "./IndustryInfo.vue?vue&type=script&lang=js&"
import style0 from "./IndustryInfo.vue?vue&type=style&index=0&id=c971b3c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971b3c4",
  null
  
)

export default component.exports